import React, { useEffect, useState } from "react";
import { NavLink, Outlet, Route, Routes, useParams } from "react-router-dom";
import { useApi } from "../../context/ApiProvider";
import ClientAdministrators from "./ClientAdministrators";
import ClientSettings from "./ClientSettings";
import OrganisationTree from "../Helpers/OrganisationTree";
import ActivityIndicator from "../Helpers/ActivityIndicator";
import { moduleName } from "../Helpers/ModuleName";
import { Formik, Form, Field } from 'formik';
import Card from "../Helpers/Card";
import moment from "moment";
import { calculateEstimatedValue, calculatePartnerProvision, sumAllModules } from './invoiceCalculations';
import ClientMembers from "./ClientMembers";
import InvoiceModal from "../Helpers/Modals/InvoiceModal";
import ClientExports from "../Clients/Exports";
import McpSettings from "../Clients/McpSettings";

export default function Client() {
  const Api = useApi();
  const { clientId } = useParams();
  const [client, setClient] = useState(false);
  const [isLoadingClient, setIsLoadingClient] = useState(false);
  const [hasPermission, setHasPermission] = useState(true);


  useEffect(() => {
    refresh()
  }, [])

  const refresh = () => {
    fetchClient();
  };

  const fetchClient = async () => {
    setIsLoadingClient(true);
    Api.get(`/rolf/clients/${clientId}`).then(data => {
      setClient(data);

    }).catch(e => {
      if (e.status === 403) {
        setHasPermission(false);
      }
    }).finally(() => {
      setIsLoadingClient(false)
    })
  }

  return (
    <Routes>
      <Route path="/*" element={<Layout client={client} />}>
        <Route index element={<ClientView view="overview" client={client} />} />
        <Route path="settings" element={<ClientView view="settings" client={client} refresh={refresh} />} />
        <Route path="mcp" element={<ClientView view="mcp" clientId={clientId} />} />
        <Route path="clientadmins" element={<ClientView view="administrators" />} />
        <Route path="invoices" element={<ClientView view="invoices" clientId={clientId} />} />
        <Route path="clientmembers" element={<ClientView view="clientmembers" />} />
        <Route path="exports" element={<ClientView view="exports" client={client} />} />
      </Route>
    </Routes>
  )
}

function Layout(props) {
  return (
    <>
      <section className='spaceBetween flexCenter orgTop'>
        <h3>{props.client.name}</h3>
        <NavLink to='/rolf'>&lt; Back  to clients list</NavLink>
      </section>
      <div className='grid-container nowrap'>
        <nav className="organisationMenu">
          <ul className="nav">
            <li>
              <NavLink to="" end className={({ isActive }) =>
                isActive ? 'active' : undefined
              }>Overview</NavLink>
            </li>
            <li>
              <NavLink to="settings" className={({ isActive }) =>
                isActive ? 'active' : undefined
              }>Information</NavLink>
            </li>
            <li>
              <NavLink to="mcp" className={({ isActive }) =>
                isActive ? 'active' : undefined
              }>Rolf AI (MCP)</NavLink>
            </li>
            <li>
              <NavLink to="invoices" className={({ isActive }) =>
                isActive ? 'active' : undefined
              }>Invoices</NavLink>
            </li>
            <li>
              <NavLink to="clientadmins" className={({ isActive }) =>
                isActive ? 'active' : undefined
              }>Administrators</NavLink>
            </li>
            <li>
              <NavLink to="clientmembers" className={({ isActive }) =>
                isActive ? 'active' : undefined
              }>Members</NavLink>

            </li>
            <li>
              <NavLink to="exports" className={({ isActive }) =>
                isActive ? 'active' : undefined
              }>Exports</NavLink>
            </li>
          </ul>
        </nav>
        <div>
          <Outlet />
        </div>
      </div>
    </>
  )
}

function ClientView(props) {



  const { view } = props;
  switch (view) {
    case 'overview':
      return (<React.Suspense fallback={<p>Loading...</p>}><section><Overview client={props.client} /></section></React.Suspense>);
    case 'settings':
      return (<React.Suspense fallback={<p>Loading...</p>}><section><ClientSettings client={props.client} refresh={props.refresh} /></section></React.Suspense>);
    case 'mcp':
      return (<React.Suspense fallback={<p>Loading...</p>}><McpSettings clientId={props.clientId} /></React.Suspense>);
    case 'administrators':
      return (<React.Suspense fallback={<p>Loading...</p>}><section><ClientAdministrators /></section></React.Suspense>);
    case 'invoices':
      return (<React.Suspense fallback={<p>Loading...</p>}><section><ClientInvoices clientId={props.clientId} /></section></React.Suspense>);
    case 'clientmembers':
      return (<React.Suspense fallback={<p>Loading...</p>}><section><ClientMembers /></section></React.Suspense>);
    case 'exports':
      return (<React.Suspense fallback={<p>Loading...</p>}><section><ClientExports client={props.client} /></section></React.Suspense>);
    default:
      return (<React.Suspense fallback={<p>Loading...</p>}><section><Overview client={props.client} /></section></React.Suspense>);
  }
}

function Overview(props) {
  const [organisations, setOrganisations] = useState([]);
  const [members, setMembers] = useState();
  const Api = useApi();
  const { clientId } = useParams();
  const [client, setClient] = useState(props.client);
  const [clientSettings, setClientSettings] = useState({});
  const [saveClientSettingsError, setSaveClientSettingsError] = useState(false);
  const [saveClientSettingsSuccess, setSaveClientSettingsSuccess] = useState(false);
  const [saveDiscrepancyError, setSaveDiscrepancyError] = useState(false);
  const [saveDiscrepancySuccess, setSaveDiscrepancySuccess] = useState(false);
  const [saveInvoiceSuccess, setSaveInvoiceSuccess] = useState(false);
  const [saveInvoiceError, setSaveInvoiceError] = useState(false);
  const [deleteDiscrepancySuccess, setDeleteDiscrepancySuccess] = useState(false);
  const [deleteDiscrepancyError, setDeleteDiscrepancyError] = useState(false);
  const [discrepancies, setDiscrepancies] = useState([]);
  const [estimatedValue, setEstimatedValue] = useState(0);
  const [partnerProvision, setPartnerProvision] = useState(0);
  const [partnerProvisionPercentage, setPartnerProvisionPercentage] = useState(0);
  const [invoices, setInvoices] = useState();
  const [invoiceDate, setInvoiceDate] = useState(moment().format('YYYY-MM-DD'));



  useEffect(() => {
    setClient(props.client);
  }, [props.client]);

  useEffect(() => {
    refresh()
  }, [])

  useEffect(() => { //Räkna ut det förväntade värdet på fakturan

    if (!clientSettings || !invoices || !members) {
      return;
    }

    let estimatedValue = calculateEstimatedValue({...client,members: members.length, settings:clientSettings}, invoices, members);
    let partnerProvision = calculatePartnerProvision({...client,members: members.length,settings:clientSettings}, invoices, members);
    let partnerProvisionPercentage = clientSettings?.partnerProvision ? parseFloat(clientSettings.partnerProvision) : 0;

    setPartnerProvisionPercentage(partnerProvisionPercentage || 0);


    setEstimatedValue(estimatedValue || 0);
    setPartnerProvision(partnerProvision || 0);

  }, [clientSettings, invoices, members])

  const refresh = () => {
    if (!clientId) return;

    fetchMembers();
    fetchOrganisations();
    fetchClientSettings();
    fetchDiscrepancies();
    fetchAllInvoices();

  }



  const fetchOrganisations = async () => {
    Api.get(`/clients/${clientId}/organisations`).then(data => {
      setOrganisations(data);
    }).catch(e => {
      console.log(e);
    })
  }

  const fetchMembers = async () => {
    Api.get(`/clients/${clientId}/members`).then(data => {
      setMembers(data);
    }).catch(e => {
      console.log(e);
    })
  }

  const fetchClientSettings = async () => {
    Api.get(`/rolf/clients/${clientId}/settings/`).then(data => {
      if (!data.priceModel) data.priceModel = 'old'; //Set old price model as default
      const { mcp, ...billingSettings } = data;
      setClientSettings(billingSettings);
    }).catch(e => {
      console.log(e);
    })
  }

  function fetchAllInvoices() {
    if (!invoiceDate) return;

    Api.get(`/rolf/clients/${clientId}/invoices`).then((data) => {
      setInvoices(data);
    }).catch((error) => {
      console.log("Error fetching invoices: ", error);
    });
  }



  const saveClientSettings = async (values) => {
    setSaveClientSettingsError(false);
    setSaveClientSettingsSuccess(false);
    await Api.post(`/rolf/clients/${clientId}/settings`, values).then(data => {
      setSaveClientSettingsSuccess('Client settings saved');
      return true;
    }).catch(e => {
      setSaveClientSettingsError(e.error);
      return false;
    }).finally(() => {
      setTimeout(() => {
        setSaveClientSettingsSuccess(false);
      }, 3000)
    })
  }

  const saveDiscrepancies = async (values) => {
    await Api.post(`/rolf/clients/${clientId}/discrepancies`, values).then(data => {
      setSaveDiscrepancySuccess('Discrepancy saved');
    }).catch(e => {
      setSaveDiscrepancyError(e.error);
    }).finally(() => {
      setTimeout(() => {
        setSaveDiscrepancySuccess(false);
        setSaveDiscrepancyError(false);
      }, 3000)
    })
  }

  const fetchDiscrepancies = async () => {
    await Api.get(`/rolf/clients/${clientId}/discrepancies`).then(data => {
      setDiscrepancies(data);
    }).catch(e => {
      console.log(e);
    })
  }

  //DELETE /rolf/clients/{id}/discrepancies/{discrepancyId}
  const deleteDiscrepancy = async (id) => {
    if (window.confirm("Are you sure you want to delete this discrepancy?")) {
      await Api.delete(`/rolf/clients/${clientId}/discrepancies/${id}`).then(() => {
        setDeleteDiscrepancySuccess('Discrepancy deleted');
        fetchDiscrepancies();
      }).catch(e => {
        console.log(e);
        setDeleteDiscrepancyError('Error deleting discrepancy');
      }).finally(() => {
        setTimeout(() => {
          setDeleteDiscrepancySuccess(false);
          setDeleteDiscrepancyError(false);
        }, 5000)
      })
    }
  }

  if (!client)
    return <ActivityIndicator color="black" />



  return (
    <div className="grid-container">
      <section className="grow">
        <h4>Overview</h4>
        <p>Here you can see an overview of the client, and manage settings and administrators.</p>

        <table>
          <thead>
            <tr>
              <th>Module:</th>
              {
                client && client.modules.split(",").map((module, index) =>
                  <th key={index}>{moduleName[module]}</th>)
              }
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Total:</strong></td>
              {
                client && client.modules.split(",").map((module, index) =>
                  <td key={index}>
                    {members && members.filter(member => member.modules && member?.modules?.some((m) => m.module == module && m.clientId == clientId)).length}
                  </td>)
              }
            </tr>
          </tbody>
        </table>

        <div className="spaceBetween">
          <div className="card small">
            <span>Total members: <strong>{members?.length}</strong></span>
          </div>
          <div className="card small">
            <span>Total nr of modules: <strong>{sumAllModules(client, members)}</strong></span>
          </div>
        </div>

        {discrepancies.length > 0 &&
          <div>
            <h4 className="spaceBetween"><span>Invoicing discrepancies</span> <span className="warning">(!)</span></h4>
            <table>
              <thead>
                <tr>
                  <th>Content</th>
                  <th>From</th>
                  <th>To</th>
                  <th>Delete</th>
                </tr>
              </thead>
              <tbody>
                {discrepancies.map((discrepancy, index) => (
                  <tr key={discrepancy.ID}>
                    <td>{discrepancy.content}</td>
                    <td>{moment.unix(discrepancy.fromDate).format("YYYY-MM-DD")}</td>
                    <td>{moment.unix(discrepancy.toDate).format("YYYY-MM-DD")}</td>
                    <td className="center"><a className="warning" onClick={() => { deleteDiscrepancy(discrepancy.ID); }}><i className="fa fa-trash"></i> Delete</a></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        }

        {deleteDiscrepancySuccess && <div className="formControlSuccess">{deleteDiscrepancySuccess}</div>}
        {deleteDiscrepancyError && <div className="formControlError">{deleteDiscrepancyError}</div>}

        <h4>Settings</h4>
        <Card>
          <Formik
            initialValues={clientSettings}
            enableReinitialize={true}
            onSubmit={(values, { setSubmitting, resetForm }) => {
              saveClientSettings(values).then(() => {
                setSubmitting(false);
                refresh();
              })
            }}>

            {({ isSubmitting }) => (
              <Form>

                <label htmlFor="contactName">Contact name</label>
                <Field type="text" name="contactName" id="contactName" className="formControl" required />


                <label htmlFor="contactEmail">Contact email</label>
                <Field type="email" name="contactEmail" id="contactEmail" className="formControl" />

                <label htmlFor="invoiceAddress">Invoice address</label>
                <Field type="text" name="invoiceAddress" id="invoiceAddress" className="formControl" />

                <label htmlFor="invoiceEmail">Invoice email</label>
                <Field type="email" name="invoiceEmail" id="invoiceEmail" className="formControl" />

                <label htmlFor="invoiceReference">Invoice reference</label>
                <Field type="text" name="invoiceReference" id="invoiceReference" className="formControl" />

                <label htmlFor="minimumLicenses">Minimum licenses</label>
                <Field type="number" name="minimumLicenses" id="minimumLicenses" className="formControl" />

                <label htmlFor="subscriptionLength">Subscription length (months, 12,6 or 3)</label>
                <Field type="number" name="subscriptionLength" id="subscriptionLength" className="formControl" placeholder='12' />

                <label htmlFor="billingInterval">Billing interval (months)</label>
                <Field as="select" name="billingInterval" id="billingInterval" className="formControl">
                  <option value={1}>Monthly</option>
                  <option value={3}>Every 3 months</option>
                  <option value={6}>Every 6 months</option>
                  <option value={12}>Every 12 months</option>
                </Field>

                <label htmlFor="organisationInChargeOfImplementation">Organisation in charge of implementation (if other than Rolf Nordic)</label>
                <Field type="text" name="organisationInChargeOfImplementation" id="organisationInChargeOfImplementation" className="formControl" placeholder='Rolf Nordic AB' />

                <label htmlFor="partnerProvision">Partner provision (%)</label>
                <Field type="number" name="partnerProvision" id="partnerProvision" className="formControl" placeholder='0' />

                <label htmlFor="implementationFee">Implementation fee</label>
                <Field type="number" name="implementationFee" id="implementationFee" className="formControl" placeholder='9900' />

                <label htmlFor="implementationFeeCommission">Partner provision on implementation fee (%)</label>
                <Field type="number" name="implementationFeeCommission" id="implementationFeeCommission" className="formControl" placeholder='0' />

                <label htmlFor="modulePrice">Module price *</label>
                <Field type="number" name="modulePrice" id="modulePrice" className="formControl" placeholder='99' />
                <p className="meta">* Will be used for all modules without a specified price below</p>

                <hr />
                <h4>Module prices</h4>
                <label htmlFor="modulePrices.reflection_price">Reflection log</label>
                <Field type="number" name="modulePrices.reflection" id="modulePrices.reflection" className="formControl" placeholder='0' />
                <label htmlFor="modulePrices.development_price">Development plan</label>
                <Field type="number" name="modulePrices.development" id="modulePrices.development" className="formControl" placeholder='0' />
                <label htmlFor="modulePrices.rolfing_price">Rolfing</label>
                <Field type="number" name="modulePrices.rolfing" id="modulePrices.rolfing" className="formControl" placeholder='0' />
                <label htmlFor="modulePrices.actionplan_price">Action plan</label>
                <Field type="number" name="modulePrices.actionplan" id="modulePrices.actionplan" className="formControl" placeholder='0' />
                <label htmlFor="modulePrices.pulse_price">Pulse</label>
                <Field type="number" name="modulePrices.pulse" id="modulePrices.pulse" className="formControl" placeholder='0' />

                <hr />

                <label htmlFor="priceModel">Price model</label>
                <Field as="select" name="priceModel" id="priceModel" className="formControl">
                  <option value="new">New Price Model (Module Based Price) - Default</option>
                  <option value="old">Old Price Model (Modules * Users)</option>
                </Field>

                <button type="submit" disabled={isSubmitting}>Save client settings {isSubmitting && <ActivityIndicator />}</button>

                {saveClientSettingsSuccess && <div className="formControlSuccess">{saveClientSettingsSuccess}</div>}
                {saveClientSettingsError && <div className="formControlError">{saveClientSettingsError}</div>}

              </Form>
            )}
          </Formik>
        </Card>

      </section>
      <section>
        <h4>Organisation tree</h4>
        {organisations.length > 0 && <OrganisationTree organisations={organisations.sort((a, b) => (a.name.toUpperCase() < b.name.toUpperCase()) && -1 || 1)} />}

        <h4>Add invoice</h4>
        <Card>
          {
            <Formik
              initialValues={{ clientId, invoiceDate: moment().format("YYYY-MM-DD"), invoiceData: { value: (estimatedValue?.total || 0), commission: partnerProvision, invoicePaid: false, commissionInvoiced: false, commissionPaid: false, outstandingCommission: 0, customerName: client.name, partnerId: client.partnerId, partnerName: client.partner, commissionPercentage: (partnerProvisionPercentage || 0) } }}
              enableReinitialize={true}
              onSubmit={(values, { setSubmitting, resetForm }) => {
                values.invoiceDate = moment(values.invoiceDate).unix();

                Api.post("/rolf/invoices", values).then(() => {
                  setSaveInvoiceSuccess('Invoice saved');
                }).catch(e => {
                  console.log(e);
                  setSaveInvoiceError("Error saving invoice");
                }).finally(() => {
                  setSubmitting(false);
                  resetForm();
                })
              }}>
              {({ isSubmitting }) => (
                <Form>
                  <label htmlFor="invoiceDate">Invoice date:</label>
                  <Field type="date" name="invoiceDate" id="invoiceDate" className="formControl" required />

                  <div className="spaceBetween">
                    <label htmlFor="invoiceData.value">Value (sek):</label> <span className="meta">Estimated value: {estimatedValue?.total}:-</span>
                  </div>
                  <Field type="number" name="invoiceData.value" id="invoiceData.value" className="formControl" required />

                  <label htmlFor="invoiceData.commission">Partner Commission (SEK):</label>
                  <Field type="number" name="invoiceData.commission" id="invoiceData.commission" className="formControl" required />

                  <button type="submit" disabled={isSubmitting}>Add invoice</button>
                </Form>
              )}
            </Formik>
          }

          {saveInvoiceSuccess && <div className="formControlSuccess">{saveInvoiceSuccess}</div>}
          {saveInvoiceError && <div className="formControlError">{saveInvoiceError}</div>}
        </Card>

        <h4>Add invoicing discrepancy</h4>
        <Card>
          <Formik initialValues={{ fromDate: moment().format("YYYY-MM-DD"), toDate: moment().add(90, "days").format("YYYY-MM-DD") }} onSubmit={(values, { setSubmitting, resetForm }) => {
            values.fromDate = moment(values.fromDate).unix(); //Konvertera datum till unix timestamp
            values.toDate = moment(values.toDate).unix();
            saveDiscrepancies(values).then(() => {
              values.fromDate = moment(values.fromDate).format("YYYY-MM-DD"); //Konvertera tillbaka till datum
              values.toDate = moment(values.toDate).format("YYYY-MM-DD");
              setSubmitting(false);
              resetForm();
              refresh(); //Hämta om all data (refresh)
            })
          }}>
            {({ isSubmitting }) => (
              <Form>
                <label htmlFor="content">Content</label>
                <Field as="textarea" rows="4" name="content" id="content" className="formControl" required />

                <label htmlFor="fromDate">From date:</label>
                <Field type="date" name="fromDate" id="fromDate" className="formControl" required />

                <label htmlFor="toDate">To date:</label>
                <Field type="date" name="toDate" id="toDate" className="formControl" required />

                <button type="submit" disabled={isSubmitting}>Add discrepancy</button>
              </Form>
            )}
          </Formik>

          {saveDiscrepancySuccess && <div className="formControlSuccess">{saveDiscrepancySuccess}</div>}
          {saveDiscrepancyError && <div className="formControlError">{saveDiscrepancyError}</div>}
        </Card>
      </section>
    </div>
  )
}

const ClientInvoices = (props) => {
  const Api = useApi();
  const [invoices, setInvoices] = useState([]);
  const [modalData, setModalData] = useState({visible: false, invoice: null});

  useEffect(() => {
    fetchInvoices();
  }, [props.clientId]);

  function fetchInvoices() {
    if (!props.clientId) return;

    Api.get(`/rolf/clients/${props.clientId}/invoices`).then((result) => {
      setInvoices(result);
    }).catch((err) => {
      console.log(err);
    })
  }

  function updateInvoice(id, field) {
    let invoice = invoices.find(i => i.ID == id); //Hitta rätt faktura
    let invoiceData = JSON.parse(invoice.invoiceData);  //Parsa fakturadatan
    invoiceData[field] = !invoiceData[field]; //Invertera värdet

    if (invoiceData.invoicePaid && !invoiceData.commissionPaid && invoiceData.partnerId) { //Om provision är fakturerad men inte betald
      invoiceData.outstandingCommission = invoiceData.commission; //Sätt utestående provision till provisionen
    } else {
      invoiceData.outstandingCommission = 0; //Annars sätt utestående provision till 0
    }

    invoice.invoiceData = JSON.stringify(invoiceData); //Sätt in den nya datan

    Api.put(`/rolf/invoices/${id}`, invoice).then(() => { //Uppdatera fakturan
      fetchInvoices(); //Hämta fakturorna igen (refresh)
    }).catch(e => {
      console.log(e);
    })
  }


    function showInvoice(invoice) {
        setModalData({visible: true, invoice: invoice});
    }

    function closeModal() {
        setModalData({visible: false, invoice: null});
    }

  return (
    <>
    <section>
      <h4>Invoices</h4>
      <p>Here you can see the invoices of the current client.</p>
      <table>
        <thead>
          <tr>
            <th>Customer</th>
            <th>Invoice date</th>
            <th>Value</th>
            <th>Partner</th>
            <th>Commission (%)</th>
            <th>Commission (sek)</th>
            <th>Customer invoce paid</th>
            <th>Commission invoiced</th>
            <th>Commission paid</th>
            <th>Outstanding commission</th>
            <th>Details</th>
          </tr>
        </thead>
        <tbody>
          {invoices.length == 0 ? <tr><td colSpan={12}>No invoices, yet</td></tr> : invoices.map((invoice, index) => {
            let invoiceData = JSON.parse(invoice.invoiceData);
            return (
              <tr key={index}>
                <td>{invoiceData.customerName}</td>
                <td>{moment.unix(invoice.invoiceDate).format("YYYY-MM-DD")}</td>
                <td>{invoiceData.value}</td>
                <td>{invoiceData.partnerName}</td>
                <td>{invoiceData.commissionPercentage}</td>
                <td>{invoiceData.commission}</td>
                <td><input type='checkbox' checked={invoiceData.invoicePaid} onChange={(e) => updateInvoice(invoice.ID, "invoicePaid")}></input></td>
                <td><input type='checkbox' checked={invoiceData.commissionInvoiced} disabled={!invoiceData.invoicePaid || !invoiceData.partnerId} onChange={(e) => updateInvoice(invoice.ID, "commissionInvoiced")}></input></td>
                <td><input type='checkbox' checked={invoiceData.commissionPaid} disabled={!invoiceData.commissionInvoiced || !invoiceData.invoicePaid || !invoiceData.partnerId} onChange={(e) => updateInvoice(invoice.ID, "commissionPaid")}></input></td>
                <td>{invoiceData.outstandingCommission}</td>
                <td><a href="#" onClick={() => showInvoice(invoice)}><i className="fa fa-eye" aria-hidden="true"></i></a></td>
              </tr>
            )
          }
          )}
        </tbody>
      </table>
    </section>
    <InvoiceModal modalData={modalData} closeModal={closeModal} onRefresh={fetchInvoices} />
    </>

  )
}
